import {useMemo} from 'react';

import {RecruitingDashboardGraphs} from '../types/RecruitingDashboardTypes';

import {useGetRequest} from '../../../../../hooks/useGetRequest';
import {getPipelineHistory} from '../../../../../lib/api/v1';
import {SerializeTo} from '../../../../../utils/serializer/serialize';

export const useMatchesGraph = (companyId: string, yearParams?: number) => {
  const fetchMatchesGraph = useMemo(() => {
    return () => getPipelineHistory(companyId, yearParams);
  }, [companyId, yearParams]);

  const {data, loading, error} = useGetRequest(fetchMatchesGraph, SerializeTo.CamelCase<RecruitingDashboardGraphs>);

  return {
    data,
    loading,
    error,
  };
};
